import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import StatusLabelField from 'components/show/StatusLabelField';

export const STATUS_PAID = 'paid';
export const STATUS_OPEN = 'open';
export const STATUS_OVERDUE = 'overdue';
export const STATUS_PAID_MANUALLY = 'paid_manually';
export const STATUS_CHARGED_BACK = 'charged_back';

const statusColours = {
    [STATUS_OPEN]: theme.palette.gray,
    [STATUS_OVERDUE]: theme.palette.tomato,
    [STATUS_PAID]: theme.palette.mossGreen,
};

const InvoiceStatus = (props) => {
    const {
        record,
        source,
        translate,
    } = props;

    const status = record[source];

    return <StatusLabelField
        background={ statusColours[status] || theme.palette.gray }
        label={ translate(`resources.invoices.status.${ status }`) }
    />;
};

InvoiceStatus.propTypes = {
    record: PropTypes.shape({
        status: PropTypes.string.isRequired,
    }).isRequired,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(InvoiceStatus);



// WEBPACK FOOTER //
// ./src/pages/invoices/show/InvoiceStatus.js